module.exports = __webpack_public_path__ + "assets/img/tiger4.6df31a23.jpg";